import React from 'react'
import { Link } from 'gatsby'
import { PublishDate, ArticleHeadline } from '@@components/common'
import styles from './HomepageArticles.module.scss'

export const HomepageArticles = ({ articles }) => (
  articles.map((article => (
    <article
      key={article.id}
      className={styles.article}
    >
      <Link to={article.url}>
        <PublishDate date={article.date} className={styles.publishDate} />
        <ArticleHeadline headline={article.title} />
        <p className={styles.excerpt}>
          {article.excerpt}
        </p>
      </Link>
    </article>
  )))
)
